var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasImgStoryError)?_c('bubble-image',{attrs:{"url":_vm.storyUrl},on:{"error":_vm.onImageLoadError}}):(!_vm.hasVideoStoryError)?_c('bubble-video',{attrs:{"url":_vm.storyUrl},on:{"error":_vm.onVideoLoadError}}):_c('instagram-story-error-place-holder')
}
var staticRenderFns = []

export { render, staticRenderFns }